import React from "react";
import { Phone, Mail } from "lucide-react";
import { SITE } from "../site.config";

export default function StickyBottomBar() {
  return (
    <div
      data-testid="sticky-bottom-bar"
      className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-white border-t border-gray-200 shadow-[0_-6px_24px_rgba(15,38,92,0.08)] safe-bottom"
    >
      <div className="grid grid-cols-3 items-stretch">
        <a
          data-testid="sticky-call-button"
          href={`tel:${SITE.phoneTel}`}
          className="flex flex-col items-center justify-center gap-0.5 py-2.5 text-moffat-navy active:bg-gray-50 transition-colors"
        >
          <Phone size={20} strokeWidth={2.5} />
          <span className="text-[11px] font-bold uppercase tracking-wide">
            Call
          </span>
        </a>
        <a
          data-testid="sticky-whatsapp-button"
          href={SITE.whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Chat on WhatsApp"
          className="flex items-center justify-center px-1 py-1.5"
        >
          <img
            src={SITE.whatsappButtonImg}
            alt="Chat on WhatsApp"
            className="max-h-12 w-auto"
            draggable="false"
          />
        </a>
        <a
          data-testid="sticky-email-button"
          href={`mailto:${SITE.email}`}
          className="flex flex-col items-center justify-center gap-0.5 py-2.5 text-moffat-red active:bg-gray-50 transition-colors"
        >
          <Mail size={20} strokeWidth={2.5} />
          <span className="text-[11px] font-bold uppercase tracking-wide">
            Email
          </span>
        </a>
      </div>
    </div>
  );
}
